module.exports = __webpack_public_path__ + "staticcomp/img/cover.f7fb627.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/10/cover.jpg
// module id = 9Rhe
// module chunks = 39